import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	validationErrorTitle: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.validation-error-title',
		defaultMessage: 'We found errors in your import',
		description: 'Message to be shown as flag description when import validation fails',
	},
	learnMoreSpork: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.learn-more-spork',
		defaultMessage: 'Learn more about importing data into Jira',
		description: 'Learn more link description',
	},
	columnErrorsHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.column-errors-heading',
		defaultMessage: 'Formatting error:',
		description: 'Heading for column validation errors that occurred during an import',
	},
	columnErrors: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.column-errors',
		defaultMessage:
			'{heading} The header used for the following columns must match the formatting style of the data in the column. Change to another field type or remove the field from import.',
		description: 'Description of column errors and instructions on how to resolve the errors.',
	},
	missingFieldHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.missing-field-heading',
		defaultMessage: 'Missing required {missingField} field: ',
		description: 'Heading for a missing field validation error that occurred during an import',
	},
	issueLinkingColumnErrorHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.issue-linking-column-error-heading',
		defaultMessage: 'Format issues in {name} column:',
		description:
			'Heading for issue id / issue link column validation errors occured during an import',
	},
	issueLinkingColumnError: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.issue-linking-column-error',
		defaultMessage:
			'{heading} The format only supports alphanumeric characters and hyphens. Check and remove unsupported characters to move ahead with the import.',
		description:
			'Description of issue id / issue link column error and instructions on how to resolve the errors',
	},
	missingIssueIdHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.missing-issue-id-heading',
		defaultMessage: 'Missing issue ID column: ',
		description:
			'Heading for a missing issue id field validation error that occurred during an import',
	},
	missingField: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.missing-field',
		defaultMessage:
			'{heading} {isIssueId, select, true {{isIssueLinksSelected, select, true {Issue links are dependent on issue IDs. Add the Issue ID column to your import to ensure issue links are imported} other {Parent fields are mapped to and dependent on an issue id. To create this relationship in your data add an issue id to one of your column headers}}} other {We map the information in that column to a task name. Add a {missingField} field to continue the import}}.',
		description: 'Description of missing field error and how to resolve the error',
	},
	summaryMissing: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.summary-missing',
		defaultMessage:
			'<b>Missing summary</b>: Summary is a required field in Jira. It can be the task name or an overview of a task. Map the summary field to a CSV column to proceed with the import.',
		description: 'Missing summary field error',
	},
	issueIdMissing: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.issue-id-missing',
		defaultMessage:
			'<b>Missing issue IDs</b>: Issue links are dependent on issue IDs. Add the issue ID column to your import to ensure issue links are imported.',
		description: 'Missing issueid error',
	},
	emptySummary: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.empty-summary',
		defaultMessage:
			'<b>Missing summary content</b>: One or more cells in the CSV column mapped to the summary field are empty. Summary is a required field. Make sure to fill in the missing content and begin the import once again.',
		description: 'Empty summary error',
	},
	formattingErrorHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.formatting-error-heading',
		defaultMessage:
			'<b>Formatting error</b>: The data in the following CSV columns must match the selected field’s formatting style. Check and correct the format in the CSV column before restarting the import or remove the column from import.',
		description: 'Formatiing errors heading',
	},
	titleStandard: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error.title-standard',
		defaultMessage:
			'{count, plural, one {We found # error in your import} other {We found # errors in your import}}',
		description: 'Error section message heading with count',
	},
});
